import { useMemo } from "react";

interface LocationLike {
  latitude?: number | null;
  longitude?: number | null;
  addressLine1?: string | null;
  city?: string | null;
  region?: string | null;
  postalCode?: string | null;
}

export function GoogleMapEmbed({
  apiKey,
  location,
  className = "min-h-[320px] w-full rounded-[var(--border-radius)] border border-[var(--color-border)]",
}: {
  apiKey?: string;
  location: LocationLike;
  className?: string;
}) {
  const src = useMemo(() => {
    if (!apiKey) return null;
    if (location.latitude != null && location.longitude != null) {
      return `https://www.google.com/maps/embed/v1/place?key=${encodeURIComponent(apiKey)}&q=${location.latitude},${location.longitude}`;
    }
    const query = [location.addressLine1, location.city, location.region, location.postalCode]
      .filter(Boolean)
      .join(", ");
    if (!query) return null;
    return `https://www.google.com/maps/embed/v1/search?key=${encodeURIComponent(apiKey)}&q=${encodeURIComponent(query)}`;
  }, [apiKey, location]);

  if (!src) return null;

  return (
    <iframe
      title="Map"
      src={src}
      className={className}
      loading="lazy"
      allowFullScreen
      referrerPolicy="no-referrer-when-downgrade"
    />
  );
}
